import { createSlice } from '@reduxjs/toolkit';

export const articleUrlSlice = createSlice({
  name: 'articleUrl',
  initialState: '',
  reducers: {},
});

export const { reducer: articleUrlReducer } = articleUrlSlice;
